/**
 * Meeting Template Schemas — the School Journey customer-call Granola template's sections.
 *
 * This list is the ONE source both the template artifact
 * (`tooling/granola-cli/templates/school-journey-customer-call.md`, U3) and
 * the backend template-shape detector (U2) read, so they cannot drift (R6).
 * A note whose summary carries these named sections is extracted from them
 * directly and scores higher than the `auto` shape (KD5, U2/U3).
 *
 * Plan: docs/_archive/2026-10-17-plans-sweep/plans/2026-08-30-0955-feat-granola-summary-meeting-lane-plan.md
 */

export const CUSTOMER_CALL_TEMPLATE_SECTIONS = [
  'Bugs and Broken Behavior',
  'Feature Requests and Gaps',
  'Questions Raised and Not Answered',
  'Frustrations and Mood',
  'What We Committed To',
  'What They Committed To',
  'Account and Deal Context',
  'Next Steps'
] as const

export type CustomerCallTemplateSection = (typeof CUSTOMER_CALL_TEMPLATE_SECTIONS)[number]
